/**
 * Lots of other stuff concerning the search widget can be found in this
 * monstrous bowl of spaghetti, just try to add new stuff here.
 */

function conditionalRequirement(widget) {
  if(!widget) return;

  const onLocationRadio = widget.querySelector('[data-js-bind="radio-location"]');
  const courseSelector = widget.querySelector('[data-js-bind="course"]');
  const locationSelector = widget.querySelector('[data-js-bind="location"]');
  const submitButton = widget.querySelector('[data-js-bind="search-widget-submit"]');

  if(!onLocationRadio || !courseSelector || !locationSelector || !submitButton) return;

  submitButton.addEventListener('click', function(e) {
    /*
      Course selector is required when
      - looking for online courses (meaning location radio is NOT checked)
      - location radio is checked AND location selector is empty
     */
    courseSelector.required = onLocationRadio.checked ? locationSelector.value === '' : true;
  });
}

function initSearchWidget() {
  const widget = document.querySelector('[data-module="search-widget"]');
  if(!widget) return;
  conditionalRequirement(widget);
}

initSearchWidget();
